export const stateData = {
  
  //delhi-assembly
  // "delhi-assembly": {
  //   breadCrump: [
  //     {
  //       displayText: "खबरें",
  //       url: "/election/delhi-assembly",
  //       keyToShow: "",
  //     },
  //     {
  //       displayText: "निर्वाचन क्षेत्र",
  //       url: "/election/delhi-assembly/constituency-list",
  //       keyToShow: "",
  //     },

  //     {
  //       displayText: "प्रमुख उम्मीदवार",
  //       url: "/election/delhi-assembly/key-candidates-list",
  //       keyToShow: "",
  //     },
  //     {
  //       displayText: "चुनाव परिणाम",
  //       url: "/election/delhi-assembly/results",
  //       keyToShow: "",
  //     },
  //     {
  //       displayText: "एग्जिट पोल",
  //       url: "/election/delhi-assembly/exit-poll-result",
  //       keyToShow: "",
  //     },

  //     {
  //       displayText: "शेड्यूल",
  //       url: "/election/delhi-assembly/schedule",
  //       keyToShow: "",
  //     },
  //   ],
  //   masterConfigKey: "delhi_election",
  //   electionPassedCategory: "delhi-assembly",
  //   state: "Delhi",
  //   stateHindi: "दिल्ली",
  //   metaData: {
  //     title: `Delhi Chunav 2025: दिल्ली विधानसभा चुनाव 2025, Delhi Vidhan Sabha Elections, News & Schedule - NewsTak`,
  //     description: `Delhi Election: Know the latest updates on Delhi Assembly Election 2025, दिल्ली विधानसभा चुनाव, Schedule, exit poll, election results, वोटों की गिनती, चुनाव समाचार, पार्टी परिणाम, वीडियो, फोटो, विजेता उम्मीदवारों, विधानसभा चुनाव नतीजे का कवरेज, news in hindi at NewsTak.in`,
  //     keywords: `Delhi Election, Delhi Vidhan Sabha Chunav, 2025 India elections, delhi assembly election date, Delhi Vidhan Sabha Chunav news in hindi, Delhi Chunav news in hindi, दिल्ली चुनाव,दिल्ली चुनाव समाचार, दिल्ली विधानसभा चुनाव, दिल्ली इलेक्शन`,
  //   },
  //   "exit-poll-result": {
  //     electionPassedCategory: "delhi-assembly",
  //     metaData: {
  //       title: `Exit Poll 2025 : Delhi Assembly Election Exit poll, दिल्ली विधानसभा चुनाव एग्जिट पोल्स - NewsTak.in`,
  //       description: `Delhi Vidhan Sabha Chunav Exit Polls: Find the latest Delhi Assembly Election exit polls, including दिल्ली इलेक्शन एग्जिट पोल्स, दिल्ली चुनाव एग्जिट पोल्स, and दिल्ली विधानसभा इलेक्शन एग्जिट पोल्स. Stay updated with the latest news on Delhi Assembly Chunav Exit Polls from NewsTak.`,
  //       keywords: `Delhi Assembly Election Exit poll, 2025 Delhi Assembly Election Exit poll, exit poll Delhi, exit poll results, Delhi vidhan sabha exit poll, Delhi exit poll, Delhi election result exit poll, Delhi assembly, Delhi election news, Delhi vidhan sabha election exit poll, Delhi latest exit poll, exit poll of Delhi, Delhi 2025 exit poll, Delhi exit poll vidhan sabha 2024, Delhi vidhan sabha, Delhi exit poll result,`,
  //     },
  //     state: "Delhi",
  //     stateHindi: "दिल्ली",
  //     agencyName: "AgencyDL",

  //     exitDesc2019:
  //       "दिल्ली विधानसभा चुनाव 2020 के नतीजे 21 दिसंबर को आने वाले हैं, लेकिन उससे पहले एग्जिट पोल पर सबकी नजर है. दिल्ली चुनाव में सत्ताधारी बीजेपी के अलावा मुख्य विपक्षी कांग्रेस संग जेजेपी, आईएनएलडी और बसपा जैसी पार्टियां अपनी किस्मत आजमा रही हैं. इस बार का चुनाव किसानों के मुद्दे, रोजगार और महंगाई जैसे इश्यू पर लड़ा गया. बीजेपी को 10 सालों की एंटी इनकंबेंसी का भी सामना करना पड़ेगा. एग्जिट पोल से झारखंड चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोली जाती है.",
  //     exitDesc2024:`दिल्ली विधानसभा चुनाव 2025 के नतीजे 8 फरवरी को घोषित होंगे. 5 फरवरी को वोटिंग खत्म होने के बाद एग्जिट पोल जारी होंगे.   नजीतों से पहले एग्जिट पोल क्या कहते हैं? दिल्ली किसकी होगी? दिल्ली की जनता क्या चाहती है? इन सवालों के जवाब के लिए लोगों की नजरें एग्जिट पोल के नतीजों पर होगी. दिल्ली में  कुल 70 विधानसभा सीटों पर 699 उम्मीदवार मैदान में हैं. पिछले चुनाव यानी 2020 में 668 उम्मीदवार मैदान में थे. दिल्ली चुनाव में मुख्य पार्टियों में AAP, BJP और कांग्रेस के अलावा अन्य पार्टियों के उम्मीदवार अपना भाग्य आजमा रहे हैं. एग्जिट पोल के डेटा वोटिंग के बाद जारी किए जाते हैं. डेटा कलेक्शन वोटिंग के दिन होता है. वोटिंग के दिन जब मतदाता वोट डालकर बूथ से बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोलने की कोशिश की जाती है.`,
  //      currentYear: "2025",
  //     exit_2020: {
  //       type: "static",
  //       data: [
  //         {
  //           agency: "AgencyDL",
  //           pollData: [
  //             {
  //               agencyName: "CVoter",
  //               partyData: [
  //                 {
  //                   partyName: "BJP",
  //                   seats: "20-28",
  //                   midRange: 24,
  //                 },
  //                 {
  //                   partyName: "CONG+",
  //                   seats: "50-58",
  //                   midRange: 54,
  //                 },
  //                 {
  //                   partyName: "OTH",
  //                   seats: "10-16",
  //                   midRange: 13,
  //                 },
  //               ],
  //             },
  //             // {
  //             //   "agencyName": "Republic-Matrize",
  //             //   "partyData": [
  //             //     {
  //             //       "partyName": "BJP",
  //             //       "seats": "18-24",
  //             //       "midRange": 21
  //             //     },
  //             //     {
  //             //       "partyName": "CONG+",
  //             //       "seats": "55-62",
  //             //       "midRange": 58.5
  //             //     },
  //             //     {
  //             //       "partyName": "OTH",
  //             //       "seats": "05-14",
  //             //       "midRange": 9.5
  //             //     }
  //             //   ]
  //             // },
  //             // {
  //             //   "agencyName": "Dhruv Research",
  //             //   "partyData": [
  //             //     {
  //             //       "partyName": "BJP",
  //             //       "seats": "27-27",
  //             //       "midRange": 27
  //             //     },
  //             //     {
  //             //       "partyName": "CONG+",
  //             //       "seats": "57-57",
  //             //       "midRange": 57
  //             //     },
  //             //     {
  //             //       "partyName": "OTH",
  //             //       "seats": "06-06",
  //             //       "midRange": 6
  //             //     }
  //             //   ]
  //             // },
  //             // {
  //             //   "agencyName": "Today's Chanakya",
  //             //   "partyData": [
  //             //     {
  //             //       "partyName": "BJP",
  //             //       "seats": "00-00",
  //             //       "midRange": 0
  //             //     },
  //             //     {
  //             //       "partyName": "CONG+",
  //             //       "seats": "00-00",
  //             //       "midRange": 0
  //             //     },
  //             //     {
  //             //       "partyName": "OTH",
  //             //       "seats": "00-00",
  //             //       "midRange": 0
  //             //     }
  //             //   ]
  //             // },
  //             // {
  //             //   "agencyName": "Dainik Bhaskar",
  //             //   "partyData": [
  //             //     {
  //             //       "partyName": "BJP",
  //             //       "seats": "19-29",
  //             //       "midRange": 24
  //             //     },
  //             //     {
  //             //       "partyName": "CONG+",
  //             //       "seats": "44-54",
  //             //       "midRange": 49
  //             //     },
  //             //     {
  //             //       "partyName": "OTH",
  //             //       "seats": "05-16",
  //             //       "midRange": 10.5
  //             //     }
  //             //   ]
  //             // },
  //             // {
  //             //   "agencyName": "Republic-Matrize",
  //             //   "partyData": [
  //             //     {
  //             //       "partyName": "BJP",
  //             //       "seats": "18-24",
  //             //       "midRange": 21
  //             //     },
  //             //     {
  //             //       "partyName": "CONG+",
  //             //       "seats": "55-62",
  //             //       "midRange": 58.5
  //             //     },
  //             //     {
  //             //       "partyName": "OTH",
  //             //       "seats": "05-14",
  //             //       "midRange": 9.5
  //             //     }
  //             //   ]
  //             // },
  //             // {
  //             //   "agencyName": "Dhruv Research",
  //             //   "partyData": [
  //             //     {
  //             //       "partyName": "BJP",
  //             //       "seats": "27-27",
  //             //       "midRange": 27
  //             //     },
  //             //     {
  //             //       "partyName": "CONG+",
  //             //       "seats": "57-57",
  //             //       "midRange": 57
  //             //     },
  //             //     {
  //             //       "partyName": "OTH",
  //             //       "seats": "06-06",
  //             //       "midRange": 6
  //             //     }
  //             //   ]
  //             // }
  //           ],
  //           totalSeats: 70,
  //         },
  //       ],
  //     },
  //     exit_2025: {
  //       type: "api",
  //       data: "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json",
  //       dataKey: "AgencyDL",
  //     },
  //     // "assemblyPollData": "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json"
  //   },
  //   "key-candidates-list": {
  //     metaData: {
  //       title: ` Key Candidates of Delhi Assembly Election 2025, दिल्ली चुनाव के प्रमुख उम्मीदवार - NewsTak`,
  //       description: `Get the list of Delhi Assembly Election 2025 Key candidates (दिल्ली विधानसभा चुनाव के प्रमुख उम्मीदवार), including party-wise candidates, constituencies, चुनाव समाचार and other key information in Hindi at NewsTak.in.`,
  //       keywords: ` Delhi Assembly Election 2024 Key Candidate, Delhi Election 2024 Key Candidate, Delhi vidhan sabha chunav 2025 Candidate, Delhi Chunav candidate list, दिल्ली विधानसभा चुनाव 2025 उम्मीदवारों की सूची, Vidhan Sabha Election Candidate, दिल्ली चुनाव के प्रमुख उम्मीदवार`,
  //     },
  //     electionPassedCategory: "delhi-assembly",
  //     dataUrl:
  //       "https://electionresults.intoday.in/elections/2024/assembly-elections/json/ei-dashboard/2024/key-candidate/delhi-key-candidate.json",
  //     dataKey: "Delhi",
  //     dataUrlKey: "DL_KeyCandidatesURL",
  //     stateName: "Delhi",
  //     stateNameHi: "दिल्ली",
  //     electionYear: "2024",
  //   },

  //   schedule: {
  //     electionPassedCategory: "delhi-assembly",
  //     state: "Delhi",
  //     stateHindi: "दिल्ली",
  //     electionYear: "2025",
  //     metaData: {
  //       title: ` Delhi Assembly Election Schedule: दिल्ली विधानसभा चुनाव तिथि 2025, Delhi Election Schedule 2025 - NewsTak.in`,
  //       description: `Delhi Vidhan Sabha Chunav Schedule 2025 : NewsTak.in provides the essential information for Delhi Assembly Election (दिल्ली विधानसभा चुनाव 2024 कार्यक्रम). Get details on dates, polling locations, and important announcements related to Delhi vidhan sabha election.`,
  //       keywords: ` Delhi Assembly Election Schedule 2025, विधानसभा चुनाव 2025 कार्यक्रम, Delhi election dates, दिल्ली विधानसभा चुनाव, polling information, Delhi election updates, Delhi voter guide, Delhi politics, Delhi vidhan sabha elections, assembly election full schedule, दिल्ली विधानसभा चुनाव तिथि, दिल्ली चुनाव समाचार`,
  //     },
  //     votingDate: "05 फरवरी 2025",
  //     resultDate: "08 फरवरी 2025",
  //     scheduleDesc: `दिल्ली की 70 विधानसभा सीटों के लिए चुनाव फरवरी 2025 में एक ही चरण में होने की संभावना है। चुनाव आयोग के अनुसार, मतदान 05 फरवरी को आयोजित किया जाएगा। मतगणना 08 फरवरी को होगी और इसी दिन चुनाव परिणाम घोषित किए जाएंगे।`,
  //   },
  //   results: {
  //     metaData: {
  //       title: ` Delhi Assembly Election Results 2025: दिल्ली विधानसभा चुनाव परिणाम, Delhi Chunav Results 2025 - NewsTak.in`,
  //       description: `Delhi Vidhan Sabha Chunav Results 2025 : Delhi Election Results, NewsTak पर जाने दिल्ली विधानसभा चुनाव परिणाम 2025, चुनाव विश्लेषण, वोटों की गिनती, चुनाव समाचार, पार्टी परिणाम, वीडियो, फोटो, विजेता उम्मीदवारों, विधानसभा चुनाव नतीजे का कवरेज`,
  //       keywords: ` elections, Delhi Chunav results live, election results, Delhi Assembly election results, Delhi election results live, Delhi assembly Election 2025 Result, counting of votes for Delhi Assembly Election, Delhi Assembly Election Results live, Delhi election results, congress results updates, दिल्ली विधानसभा चुनाव, 2025 दिल्ली विधानसभा चुनाव परिणाम, चुनाव परिणाम, विधानसभा चुनाव परिणाम, चुनाव 2025, विधानसभा चुनाव 2024 परिणाम`,
  //     },
  //     electionPassedCategory: "delhi-assembly",
  //     state: "Delhi",
  //     stateHindi: "दिल्ली",
  //     currentYear: "2025",
  //     oldResult: {
  //       partyData: [
  //         {
  //           partyName: "AAP",
  //           color: "#19AAED",
  //           partySeat: 62,
  //         },
  //         {
  //           color: "#FF9933",
  //           partyName: "BJP",
  //           partySeat: "08",
  //         },

  //         {
  //           color: "#CC0000",
  //           partyName: "OTH",
  //           partySeat: "00",
  //         },
  //       ],
  //     },
  //     resultKey: "partiesDataDL",
  //     oldDesc:
  //       "Delhi Assembly Elections Results 2020:  इस बार के दिल्ली विधानसभा चुनाव में कौन मारेगा बाजी? आम आदमी पार्टी (AAP) लगातार चौथी बार बनाएगी सरकार या भारतीय जनता पार्टी (BJP) को मिलेगा जनता का साथ या कांग्रेस (Congress) कर सकती है कमाल? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. तब तक जानिए 2020 के चुनाव में किस पार्टी का क्या था हाल?",
  //     newDesc:
  //       "Delhi Assembly Elections Results 2025:इस बार के दिल्ली विधानसभा चुनाव में कौन मारेगा बाजी? आम आदमी पार्टी (AAP) लगातार चौथी बार बनाएगी सरकार या भारतीय जनता पार्टी (BJP) को मिलेगा जनता का साथ या कांग्रेस (Congress) कर सकती है कमाल? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. ",
  //     prevDataUrl:
  //       "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2014-all-consituency.json",
  //     currentDataUrl:
  //       "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2019-all-consituency.json",
  //     2014: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2014-all-consituency.json",
  //     2019: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2019-all-consituency.json",
  //     // "2024" : "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-2019-all-consituency.json",
  //     2024: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/state/delhi-all-consituency.json",
  //     constituency: {
  //       //this is used in url
  //       state: "Delhi",
  //       stateHindi: "दिल्ली",
  //       url3Key: "ConstituencyDetailURL",
  //       url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/jharkhand/",
  //       // "url3": "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/7047",
  //       url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
  //       url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json",
  //     },
  //   },
  //   "constituency-list": {
  //     electionPassedCategory: "delhi-assembly",
  //     state: "Delhi",
  //     stateHindi: "दिल्ली",
  //     currentYear: "2024",
  //     metaData: {
  //       title: `Delhi Assembly Election 2025: Delhi Chunav Constituency List, दिल्ली विधानसभा निर्वाचन क्षेत्र सूची - NewsTak`,
  //       description: `Delhi Assembly Election Constituency: Get the complete list of Delhi Vidhan Sabha constituencies, दिल्ली विधानसभा चुनाव निर्वाचन क्षेत्र, पार्टी उम्‍मीदवार, चुनाव की खबरें, फोटो एवं वीडियो, Delhi Chunav updates and दिल्ली चुनाव समाचार at NewsTak.in`,
  //       keywords: `Delhi Assembly Election, Delhi Vidhan Sabha Constituency List, दिल्ली विधानसभा चुनाव, दिल्ली चुनाव समाचार, Delhi Chunav Constituencies list, दिल्ली विधानसभा चुनाव निर्वाचन क्षेत्र, दिल्ली विधानसभा निर्वाचन क्षेत्र, delhi news, दिल्ली विधानसभा समाचार`,
  //     },
  //     constituency_urls: {
  //       //this is used in url
  //       state: "Delhi",
  //       stateHindi: "दिल्ली",
  //       url3Key: "ConstituencyDetailURL",
  //       url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/delhi/",

  //       url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
  //       url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-state-master.json",
  //     },
  //   },
  //   constituencies: {
  //     electionPassedCategory: "delhi-assembly",
  //     state: "Delhi",
  //     stateHindi: "दिल्ली",
  //     currentYear: "2024",
  //   },
  //   candidates: {
  //     electionPassedCategory: "delhi-assembly",
  //     state: "Delhi",
  //     stateHindi: "दिल्ली",
  //     currentYear: "2024",
  //   },
  //   tallyState: "delhi",
  // },

  
};
